import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export interface TextProps extends Omit<TypographyProps, 'children' | 'sx'> {
  content: string;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body1' | 'body2' | 'caption' | 'subtitle1' | 'subtitle2';
  color?: 'primary' | 'secondary' | 'textPrimary' | 'textSecondary' | 'error' | 'warning' | 'info' | 'success';
  truncate?: boolean;
  maxLines?: number;
  sx?: SxProps<Theme>;
}

const Text = ({
  content,
  variant = 'body1',
  color = 'textPrimary',
  truncate = false,
  maxLines,
  sx,
  ...props
}: TextProps) => {
  const getTruncateStyles = (): SxProps<Theme> => {
    if (!truncate && !maxLines) return {};
    
    if (maxLines) {
      return {
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical' as const,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      };
    }
    
    return {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
  };

  const combinedSx: SxProps<Theme> = [
    getTruncateStyles(),
    ...(Array.isArray(sx) ? sx : [sx]),
  ];

  return (
    <Typography
      variant={variant}
      color={color}
      sx={combinedSx}
      {...props}
    >
      {content}
    </Typography>
  );
};

export default Text; 